// D152.4: an invoice line's Description is worth showing only when it adds something to the name.
// Same test the line drawer always used: equal ignoring case and surrounding spaces = the same text.
export function descriptionDiffersFromName(name?: string | null, description?: string | null): boolean {
  return (description || '').trim().toLowerCase() !== (name || '').trim().toLowerCase();
}
